import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable @typescript-eslint/no-non-null-assertion, max-lines */
import * as React from 'react';
import isEqual from 'react-fast-compare';
import { mergeStyles } from '@cian/utils';
import * as styles from './NewbuildingCarousel.css';
import { getBlockWidth, getCurrentMedia, calculateWidth, calculateWidthSSR, calculateOffset, calculateOffsetSSR, calculateNextSlide, checkBoundaryValues, getSlides, getUniversalPosition, getCoordinates, toggleCursorStyles, cleanCursorStyles, isClick } from './helpers';
import { RESIZE_TROTTLING_DELAY, SCROLL_TRANSITION, SCROLL_TROTTLING_DELAY, SCROLL_AREA, DEFAULT_ARROWS_SETTINGS } from './constants';
import { throttle } from '@cian/newbuilding-utils';
import { Carousel } from './parts/Carousel';
import { FirstPaintRender } from './parts/FirstPaintRender';
import { ESizeType } from './types';

/** @description Настройки карусели для ее интеграции на страницу
 * @param {IMedia[]} media Настройки ширин элементов в зависимости от ширины самой карусели
 * @param {TFirstPaintOptions} firstPaintOptions Настройки ширин элементов для серверного рендеринга
 * @param {React.ReactNode[]} slides Массив элементов для отображения в карусели
 * @param {number} defaultCurrentSlide? Начальный слайд (по умолчанию равен числу слайдов на экране)
 * @param {(props: TOnSlideChangeParams): void} slidedChangeCallback? Коллбек смены слайда
 * @param {(id: number): void} onSlideClick? Коллбек клика по слайду
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var NewbuildingCarousel = /*#__PURE__*/function (_React$Component) {
  _inherits(NewbuildingCarousel, _React$Component);
  var _super = _createSuper(NewbuildingCarousel);
  function NewbuildingCarousel(props) {
    var _this;
    _classCallCheck(this, NewbuildingCarousel);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "changeSlidesContainerTransition", function (newValue) {
      if (_this.slidesContainerRef.current) {
        _this.slidesContainerRef.current.style.transition = newValue;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "computeDimensions", function () {
      var totalSlides = _this.state.totalSlides;
      var blockWidth = getBlockWidth(_this.carouselContainerRef.current);
      var currentMedia = getCurrentMedia(blockWidth, _this.props.media);
      var _currentMedia$setting = currentMedia.settings,
        elementsWidth = _currentMedia$setting.elementsWidth,
        slidesToShow = _currentMedia$setting.slidesToShow,
        height = _currentMedia$setting.height,
        slidesToScroll = _currentMedia$setting.slidesToScroll,
        defaultControls = _currentMedia$setting.defaultControls,
        draggableMediaSetting = _currentMedia$setting.draggable,
        _currentMedia$setting2 = _currentMedia$setting.arrowsSettings,
        arrowsSettings = _currentMedia$setting2 === void 0 ? DEFAULT_ARROWS_SETTINGS : _currentMedia$setting2;
      var draggable = draggableMediaSetting && totalSlides > slidesToShow;
      var currentWidth = calculateWidth(blockWidth, elementsWidth, slidesToShow);
      var currentSlide = checkBoundaryValues(_this.getPreviousSlide(), slidesToShow, totalSlides);
      _this.slidesLeftOffset = calculateOffset({
        leftEarWidth: currentWidth.leftEar,
        gapWidth: currentWidth.gap,
        slideWidth: currentWidth.slide,
        currentSlideIndex: currentSlide - 1,
        slidesToShow: slidesToShow
      });
      _this.changeSlidesContainerTransition('none');
      if (draggable) {
        toggleCursorStyles(false, _this.carouselContainerRef);
      } else {
        cleanCursorStyles(_this.carouselContainerRef);
      }
      _this.setState({
        isLoaded: true,
        width: currentWidth,
        height: height,
        currentSlide: currentSlide,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        slidesLeftOffset: _this.slidesLeftOffset,
        defaultControls: defaultControls,
        draggable: draggable,
        arrowsSettings: arrowsSettings
      });
    });
    _defineProperty(_assertThisInitialized(_this), "addScrollWithKeyboard", function () {
      /* istanbul ignore next */
      _this.carouselContainerRef.current.addEventListener('keydown', _this.scrollWithKeyboard);
    });
    _defineProperty(_assertThisInitialized(_this), "removeScrollWithKeyboard", function () {
      /* istanbul ignore next */
      _this.carouselContainerRef.current.removeEventListener('keydown', _this.scrollWithKeyboard);
    });
    _defineProperty(_assertThisInitialized(_this), "scrollWithKeyboard", function (event) {
      var _this$state = _this.state,
        currentSlide = _this$state.currentSlide,
        slidesToShow = _this$state.slidesToShow,
        totalSlides = _this$state.totalSlides;
      if ((event.key === 'ArrowLeft' || event.key === 'Left') && currentSlide > slidesToShow) {
        _this.handleSlideChange(-1);
      } else if ((event.key === 'ArrowRight' || event.key === 'Right') && currentSlide < totalSlides) {
        _this.handleSlideChange(1);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleSlideChange", function (direction) {
      var _this$state2 = _this.state,
        currentSlide = _this$state2.currentSlide,
        slidesToScroll = _this$state2.slidesToScroll,
        slidesToShow = _this$state2.slidesToShow,
        totalSlides = _this$state2.totalSlides;
      var nextSlide = calculateNextSlide({
        currentSlide: currentSlide,
        totalSlides: totalSlides,
        direction: direction,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow
      });
      _this.throttledScrollToSlide(nextSlide);
    });
    _defineProperty(_assertThisInitialized(_this), "getPreviousSlide", function () {
      var _this$state3 = _this.state,
        totalSlides = _this$state3.totalSlides,
        slidesToShow = _this$state3.slidesToShow,
        prevSlide = _this$state3.currentSlide;
      return totalSlides < slidesToShow ? slidesToShow : prevSlide;
    });
    _defineProperty(_assertThisInitialized(_this), "handleMoveStart", function (e) {
      var onSlideClick = _this.props.onSlideClick;
      var draggable = _this.state.draggable;
      if (!draggable) {
        return;
      }
      if (onSlideClick) {
        var currentPosition = getUniversalPosition(e);
        // Не выполняется при клике.
        if (isClick(_this.lastCursorPosition, currentPosition)) {
          return;
        }

        /* Запоминаем позицию курсора при опущенной лкм/начале тача для дифференциации клика/свайпа
           при событии onClick у слайда
        */
        _this.lastCursorPosition = currentPosition;
      }
      e.persist();
      _this.toggleMove(true); // навешиваем хендлеры, добавляем стили для анимации
      _this.lastCursorPosition = getUniversalPosition(e); // запоинаем позицию клика с которого началось движение
    });
    _defineProperty(_assertThisInitialized(_this), "handleSlideClick", function (id, event) {
      if (!_this.props.onSlideClick) {
        return;
      }
      var currentPosition = getUniversalPosition(event);

      // Не выполняется при свайпе.
      if (!isClick(_this.lastCursorPosition, currentPosition)) {
        return;
      }
      _this.props.onSlideClick(id);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMoveEnd", function (e) {
      if (!_this.isScrolling) {
        return;
      }
      var containerWidth = _this.state.width.container;
      var _getCoordinates = getCoordinates(e, _this.lastCursorPosition),
        deltaX = _getCoordinates.deltaX,
        lastX = _getCoordinates.lastX,
        x = _getCoordinates.x;
      _this.toggleMove(false);

      /* istanbul ignore next */
      if (Math.abs(deltaX) > containerWidth * SCROLL_AREA) {
        // если мы протянули слад больше чем на треть
        var direction = lastX < x ? -1 : 1;
        _this.handleSlideChange(direction); // скролим до слайда
      } else {
        // если нет - возвращаемся на исходную позицию
        _this.changeSlidesContainerTransition(SCROLL_TRANSITION);
        _this.slidesContainerRef.current.style.transform = "translateX(".concat(_this.slidesLeftOffset, "px)");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMove", function (e) {
      var _this$state$width = _this.state.width,
        leftEar = _this$state$width.leftEar,
        content = _this$state$width.content;
      var _getCoordinates2 = getCoordinates(e, _this.lastCursorPosition),
        deltaX = _getCoordinates2.deltaX;
      var shift = _this.slidesLeftOffset - deltaX;
      var maxShift = _this.slidesContainerRef.current.offsetWidth - (leftEar + content) - 1;
      var outOfRange = shift > 0 || Math.abs(shift) >= maxShift;
      if (!_this.isScrolling || outOfRange) {
        return;
      }

      // скролим слайды за мышкой
      _this.slidesContainerRef.current.style.transform = "translateX(".concat(shift, "px)");
    });
    _defineProperty(_assertThisInitialized(_this), "scrollToSlide", function (nextSlide) {
      var _this$state4 = _this.state,
        _this$state4$width = _this$state4.width,
        leftEar = _this$state4$width.leftEar,
        gap = _this$state4$width.gap,
        slide = _this$state4$width.slide,
        slidesToShow = _this$state4.slidesToShow,
        currentSlide = _this$state4.currentSlide,
        totalSlides = _this$state4.totalSlides;
      var onSlideChange = _this.props.onSlideChange;
      _this.slidesLeftOffset = calculateOffset({
        leftEarWidth: leftEar,
        gapWidth: gap,
        slideWidth: slide,
        currentSlideIndex: nextSlide - 1,
        slidesToShow: slidesToShow
      });
      _this.changeSlidesContainerTransition(SCROLL_TRANSITION);
      _this.setState({
        currentSlide: nextSlide,
        slidesLeftOffset: _this.slidesLeftOffset
      }, function () {
        if (onSlideChange) {
          onSlideChange({
            prevSlide: currentSlide,
            currentSlide: nextSlide,
            totalSlides: totalSlides
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "throttledResizeHandler", throttle(RESIZE_TROTTLING_DELAY, _this.computeDimensions));
    _defineProperty(_assertThisInitialized(_this), "throttledScrollToSlide", throttle(SCROLL_TROTTLING_DELAY, _this.scrollToSlide));
    _defineProperty(_assertThisInitialized(_this), "throttledHandleMoveStart", throttle(SCROLL_TROTTLING_DELAY, _this.handleMoveStart));
    _defineProperty(_assertThisInitialized(_this), "handleMoveStartPersisted", function (e) {
      e.persist();
      _this.throttledHandleMoveStart(e);
    });
    _defineProperty(_assertThisInitialized(_this), "carouselContainerRef", void 0);
    _defineProperty(_assertThisInitialized(_this), "slidesContainerRef", void 0);
    _defineProperty(_assertThisInitialized(_this), "stylesSSR", void 0);
    _defineProperty(_assertThisInitialized(_this), "lastCursorPosition", void 0);
    _defineProperty(_assertThisInitialized(_this), "slidesLeftOffset", void 0);
    _defineProperty(_assertThisInitialized(_this), "isScrolling", void 0);
    _defineProperty(_assertThisInitialized(_this), "toggleMove", function (on) {
      var togglerFn = on ? window.addEventListener : window.removeEventListener;
      if (on) {
        _this.changeSlidesContainerTransition('none');
      }
      _this.isScrolling = on;
      toggleCursorStyles(on, _this.carouselContainerRef);
      togglerFn('contextmenu', _this.handleMoveEnd);
      togglerFn('mouseup', _this.handleMoveEnd);
      togglerFn('touchend', _this.handleMoveEnd);
      togglerFn('mousemove', _this.handleMove);
      togglerFn('touchmove', _this.handleMove);
    });
    _defineProperty(_assertThisInitialized(_this), "getCarouselHeight", function () {
      var height = _this.state.height;
      return height.type === ESizeType.PERCENT ? "".concat(height.value, "%") : "".concat(height.value, "px");
    });
    _this.carouselContainerRef = /*#__PURE__*/React.createRef();
    _this.slidesContainerRef = /*#__PURE__*/React.createRef();
    _this.lastCursorPosition = {
      x: 0,
      y: 0
    };
    _this.slidesLeftOffset = 0;
    _this.isScrolling = false;
    var _this$props$firstPain = _this.props.firstPaintOptions,
      _slidesToShow = _this$props$firstPain.slidesToShow,
      _elementsWidth = _this$props$firstPain.elementsWidth;
    var widthSSR = calculateWidthSSR(_elementsWidth, _slidesToShow);
    var _currentSlide = checkBoundaryValues(_this.props.defaultCurrentSlide || _slidesToShow, _slidesToShow, _this.props.slides.length);
    _this.stylesSSR = {
      width: widthSSR,
      slidesLeftOffset: calculateOffsetSSR({
        leftEarWidth: widthSSR.leftEar,
        gapWidth: widthSSR.gap,
        slideWidth: widthSSR.slide,
        currentSlideIndex: _currentSlide - 1,
        slidesToShow: _slidesToShow
      })
    };
    _this.setInitialCarouselState();
    return _this;
  }

  /** @description применение настроек карусели согласно текущему значению ширины контейнера (вместо настроек из
   * firstPaintOptions) добавление обработчика на изменение ширины экрана
   */
  _createClass(NewbuildingCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.throttledResizeHandler);
      this.computeDimensions();
      if (this.state.draggable) {
        toggleCursorStyles(false, this.carouselContainerRef);
      }
      this.changeSlidesContainerTransition(SCROLL_TRANSITION);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.throttledResizeHandler);
      this.toggleMove(false);
    }

    /** @description изменение текущего слайда при изменении его значения в пропсах
     * @param {INewbuildingCarouselProps} prevProps предыдущие просы карусели
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        defaultCurrentSlide = _this$props.defaultCurrentSlide,
        slides = _this$props.slides;
      var _this$state5 = this.state,
        slidesToShow = _this$state5.slidesToShow,
        totalSlides = _this$state5.totalSlides,
        width = _this$state5.width;
      if (prevProps.slides.length !== slides.length || !isEqual(prevProps.slides, slides)) {
        var currentSlide = checkBoundaryValues(defaultCurrentSlide || this.getPreviousSlide(), slidesToShow, slides.length);
        this.slidesLeftOffset = calculateOffset({
          leftEarWidth: width.leftEar,
          gapWidth: width.gap,
          slideWidth: width.slide,
          currentSlideIndex: currentSlide - 1,
          slidesToShow: slidesToShow
        });
        this.setState({
          slides: getSlides(slides),
          totalSlides: slides.length,
          currentSlide: currentSlide,
          slidesLeftOffset: this.slidesLeftOffset
        });
      }
      if (defaultCurrentSlide && defaultCurrentSlide !== prevProps.defaultCurrentSlide && defaultCurrentSlide !== this.state.currentSlide) {
        var nextSlide = checkBoundaryValues(defaultCurrentSlide, slidesToShow, totalSlides);
        this.throttledScrollToSlide(nextSlide);
      }
    }

    /** @description Изменяет значение анимации для слайдов
     * @param {string} newValue новое значение анимации
     */
  }, {
    key: "setInitialCarouselState",
    value: function setInitialCarouselState() {
      var _this$props2 = this.props,
        _this$props2$firstPai = _this$props2.firstPaintOptions,
        slidesToShow = _this$props2$firstPai.slidesToShow,
        elementsWidth = _this$props2$firstPai.elementsWidth,
        height = _this$props2$firstPai.height,
        defaultControls = _this$props2$firstPai.defaultControls,
        draggable = _this$props2$firstPai.draggable,
        defaultCurrentSlide = _this$props2.defaultCurrentSlide,
        slides = _this$props2.slides;
      var currentSlide = checkBoundaryValues(defaultCurrentSlide || slidesToShow, slidesToShow, slides.length);

      // Вызывается в конструкторе
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state = {
        width: calculateWidth(0, elementsWidth, slidesToShow),
        height: height,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        currentSlide: currentSlide,
        slides: getSlides(slides),
        totalSlides: slides.length,
        slidesLeftOffset: 0,
        defaultControls: defaultControls,
        draggable: draggable && slides.length > slidesToShow,
        isLoaded: false,
        arrowsSettings: DEFAULT_ARROWS_SETTINGS
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state6 = this.state,
        width = _this$state6.width,
        currentSlide = _this$state6.currentSlide,
        slidesLeftOffset = _this$state6.slidesLeftOffset,
        totalSlides = _this$state6.totalSlides,
        slidesToShow = _this$state6.slidesToShow,
        slides = _this$state6.slides,
        isLoaded = _this$state6.isLoaded,
        defaultControls = _this$state6.defaultControls,
        arrowsSettings = _this$state6.arrowsSettings;
      return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['carousel-container'], arrowsSettings.alwaysVisible && styles['carousel-container__arrows-always-visible'], {
        height: this.getCarouselHeight()
      })), {}, {
        ref: this.carouselContainerRef,
        onFocus: this.addScrollWithKeyboard,
        onBlur: this.removeScrollWithKeyboard,
        onMouseDown: this.handleMoveStartPersisted,
        onTouchStart: this.handleMoveStartPersisted,
        tabIndex: 1,
        children: isLoaded ? /*#__PURE__*/_jsx(Carousel, {
          width: width,
          slides: slides,
          currentSlide: currentSlide,
          slidesToShow: slidesToShow,
          totalSlides: totalSlides,
          slidesLeftOffset: slidesLeftOffset,
          slidesContainerRef: this.slidesContainerRef,
          handleArrowClick: this.handleSlideChange,
          handleSlideClick: this.handleSlideClick,
          defaultControls: defaultControls,
          defaultArrowStyles: styles['default-arrows-wrapper'],
          arrowsSettings: arrowsSettings
        }) : /*#__PURE__*/_jsx(FirstPaintRender, {
          widthSSR: this.stylesSSR.width,
          slides: slides,
          slidesLeftOffsetSSR: this.stylesSSR.slidesLeftOffset,
          currentSlide: currentSlide,
          totalSlides: totalSlides,
          slidesToShow: slidesToShow,
          defaultControls: defaultControls,
          arrowsSettings: arrowsSettings
        })
      }));
    }
  }]);
  return NewbuildingCarousel;
}(React.Component);